import { render } from "./CardPuntoEntrega.vue?vue&type=template&id=78e5f3fa"
import script from "./CardPuntoEntrega.vue?vue&type=script&lang=js"
export * from "./CardPuntoEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__